import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import BackIcon from "assets/icons/back.svg?react";
import ArrowLeftIcon from "assets/icons/arrow_l.svg?react";
import settingService from "api/settingsService";
import HollowButton from "components/HollowButton";
import Button from "components/Button";
import Dropdown from "components/Dropdown";
import { IDropdownObject } from "components/Dropdown/typings";
import { ICalendarIntegrationSettings } from "dto/Settings/ICalendarIntegrationSettings";
import { useTranslation } from "react-i18next";
import { ENotificationType, notification } from "utils/notification";

const CalendarSettings: FC<Props> = ({
  integrationId,
  onCanceled,
  handleDisconnect,
}) => {
  const { t } = useTranslation();
  const { data: settingsData } = settingService.useGetCalendarSettings();
  const [defaultCalendar, setDefaultCalendar] = useState<string | null>(null);
  const [calendars, setCalendars] = useState<Array<IDropdownObject>>([]);

  const save = () => {
    // updatePassword(
    //   {
    //     OldPassword: passwords.currentPass,
    //     NewPassword: passwords.newPass,
    //     RepeatPassword: passwords.newPassRepeat,
    //   },
    //   {
    //     onSuccess(data, variables, context) {
    //       onSaved();
    //     },
    //     onError(e: any) {
    //       setError(getErrorMessage(e.response.data));
    //     },
    //   }
    // );
  };

  const onChange = () => {};

  useEffect(() => {
    if (settingsData) {
      const resp: ICalendarIntegrationSettings = settingsData.data;

      setCalendars(
        resp.calendars.map((x) => {
          return { name: x.name, value: x.id };
        }),
      );
      setDefaultCalendar(resp.defaultCalendarId);
    }
  }, [settingsData]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.pathBar}>
        <div className={styles.backButton}>
          <BackIcon onClick={onCanceled}></BackIcon>
        </div>
        {t("integrations.title")} <ArrowLeftIcon></ArrowLeftIcon>{" "}
        {t("integrations.calendarSync")}
      </div>

      <div className={styles.hint}>
        {t("integrations.calendarDescription")}
      </div>
      <Dropdown
        label={t("integrations.calendar")}
        defaultValue={defaultCalendar}
        list={calendars}
        onChange={onChange}
        allowNull={true}
      ></Dropdown>

      <div className={styles.disconnect}>
        <a onClick={() => handleDisconnect(integrationId)}>
          {t("integrations.disconnectAccount")}
        </a>
      </div>
      <div className={styles.hint}>
        {t("integrations.disconnectWarning")}
      </div>

      {/* {error && <div className={styles.warn}>{error}</div>} */}
      <div className={styles.buttons}>
        <HollowButton
          text={t("common.cancel")}
          onClick={onCanceled}
        ></HollowButton>
        <Button text={t("common.save")} onClick={save}></Button>
      </div>
    </div>
  );
};

export default CalendarSettings;
